var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#828282"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tablet"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1592,
    height: 1291,
    transform: "translate(-175 -1115)",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user tablet"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -87.5,
    y: -235.5,
    width: 135,
    height: 291,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Variant2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-67.7 -13C-67.7 -15.5957 -65.5957 -17.7 -63 -17.7H27.7V31C27.7 33.5957 25.5957 35.7 23 35.7H-63C-65.5957 35.7 -67.7 33.5957 -67.7 31V-13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.7 -13C-67.7 -15.5957 -65.5957 -17.7 -63 -17.7H27.7V31C27.7 33.5957 25.5957 35.7 23 35.7H-63C-65.5957 35.7 -67.7 33.5957 -67.7 31V-13Z",
    stroke: "#DBDBDB",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 18V16H16V2H9V0H16C16.55 0 17.021 0.195667 17.413 0.587C17.8043 0.979 18 1.45 18 2V16C18 16.55 17.8043 17.021 17.413 17.413C17.021 17.8043 16.55 18 16 18H9ZM7 14L5.625 12.55L8.175 10H0V8H8.175L5.625 5.45L7 4L12 9L7 14Z",
    fill: "#1B2831"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.027c047985635b632cc9ef2c5c565068.svg";
export { ForwardRef as ReactComponent };